
      module.exports = {
        functional: true,
        render(_h, _vm) {
          const { _c, _v, data, children = [] } = _vm;

          const {
            class: classNames,
            staticClass,
            style,
            staticStyle,
            attrs = {},
            ...rest
          } = data;

          return _c(
            'svg',
            {
              class: [classNames,staticClass],
              style: [style,staticStyle],
              attrs: Object.assign({"xmlns":"http://www.w3.org/2000/svg","viewBox":"0 0 55 46"}, attrs),
              ...rest,
            },
            children.concat([_c('g',{attrs:{"fill":"none"}},[_c('path',{attrs:{"fill":"#FFF","d":"M3.146.002A3.141 3.141 0 000 3.15v32.486a3.141 3.141 0 003.146 3.147h24.182c.38 0 .666-.29.666-.666a.654.654 0 00-.666-.666H3.146a1.839 1.839 0 01-1.83-1.831V10.685h45.51v7.479a.64.64 0 00.655.654h.004a.65.65 0 00.662-.662V3.146A3.141 3.141 0 0045 0L3.146.002zm0 1.32H45c1.003 0 1.826.824 1.826 1.827v6.22H1.315V3.15c0-1.005.828-1.826 1.83-1.826h.001z"}}),_c('path',{attrs:{"stroke":"#BF9C5F","stroke-width":"2","d":"M42.816 22.826c-5.866 0-10.635 4.765-10.635 10.635 0 5.873 4.76 10.632 10.635 10.632 5.866 0 10.632-4.763 10.632-10.632 0-5.873-4.76-10.635-10.632-10.635zm0-.68c6.238 0 11.315 5.076 11.315 11.315s-5.077 11.315-11.315 11.315c-6.231 0-11.32-5.081-11.32-11.315 0-6.24 5.08-11.315 11.32-11.315zm.002 5.97v.816a.347.347 0 00.229-.087l-.553.505v-.914l.337-.308.33.303v.931l-.35-.319.462-.51.209.19v.58h-.406l-.288-.27-.2-.187a.35.35 0 00.226.086v-.82l.004.004zm-2.974 3.656l-.207.19c.12-.111.132-.347.008-.48-.1-.109-.313-.128-.447-.038l.258-.236h.388v.564zm6.64-.3l.002.002-.001-.001zm-1.99.89l-1.675-1.534 1.675-.738v2.271zm-3.332-.003v-2.266l1.674.738-1.674 1.528z"}})])])
          )
        }
      }
    